import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"

import useToast from "../useToast"

import { useMentorCloudRenameFile } from "./useMentorCloudRenameFile"
import { useMentorCloudRenameFolder } from "./useMentorCloudRenameFolder"

import { CreateFolderFormData, createFolderSchema } from "src/schemas/mentor-cloud/CreateFolderSchema"
import { MentorCloudFileFilters } from "src/types/files/file"

export const useMentorCloudRenameForm = (
    file: { fileId?: number, fileName?: string },
    filters: MentorCloudFileFilters = { search: '', order: { column: 'name', ascending: true }, type: '*' },
    parentFolderId?: number | null,
    type?: 'file' | 'folder'
) => {
    const { notify } = useToast()

    const { control, handleSubmit, formState: { isSubmitting } } = useForm<CreateFolderFormData>({
        resolver: zodResolver(createFolderSchema),
        defaultValues: {
            name: file.fileName
        }
    })

    const { renameFile } = useMentorCloudRenameFile(filters, parentFolderId)
    const { renameFolder } = useMentorCloudRenameFolder(filters, parentFolderId)

    const onSubmit = (onSuccess?: () => void) => handleSubmit(async (formData) => {
        try {
            if (!file.fileId) return

            if (type === 'file') {
                await renameFile({
                    values: {
                        name: formData.name,
                        id: file.fileId
                    }
                })
            } else {
                await renameFolder({
                    values: {
                        name: formData.name,
                        id: file.fileId
                    }
                })
            }

            onSuccess?.()
        } catch (_error) {
            notify(type === 'file' ? 'FILE.rename' : 'FOLDER.rename', { type: 'error' })
        }
    })

    return {
        control,
        isSubmitting,
        onSubmit
    }
}